import { type FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { OpenInIcon } from '@instacart/ids-core'
import { MenuBase, NavigationBar } from '@retailer-platform/shared-components/src/tds'
import { useResolveNavHref } from './TdsNavigationBar'
import { TdsMenuItem } from './TdsMenuItem'
import { useTopBarMenu } from './TopBarMenuContext'

const ADS_MANAGER_URL = 'https://ads.instacart.com/'

type Props = {
  homeRoute: string
}

export const TdsAppSwitcher: FunctionComponent<Props> = ({ homeRoute }) => {
  const intl = useIntl()
  const history = useHistory()
  const { isOpen, setIsOpen } = useTopBarMenu('appSwitcher')
  const homeHref = useResolveNavHref({ route: homeRoute })?.href

  const trigger = (
    <NavigationBar.Button
      aria-label={intl.formatMessage({ id: 'app.nav.appSwitcher.label' })}
      icon="appLauncher"
      isActive={isOpen}
      onPress={() => setIsOpen(!isOpen)}
    />
  )

  return (
    <MenuBase target={trigger} isOpen={isOpen} onMenuStateChange={setIsOpen} position="bottomStart">
      <TdsMenuItem
        title={intl.formatMessage({ id: 'app.nav.appSwitcher.instacartPlatform.title' })}
        text={intl.formatMessage({ id: 'app.nav.appSwitcher.instacartPlatform.subtitle' })}
        onClick={() => {
          setIsOpen(false)
          if (homeHref) history.push(homeHref)
        }}
      />
      <TdsMenuItem
        title={intl.formatMessage({ id: 'app.nav.appSwitcher.adsManager.title' })}
        text={intl.formatMessage({ id: 'app.nav.appSwitcher.adsManager.subtitle' })}
        href={ADS_MANAGER_URL}
        target="_blank"
        rel="noopener noreferrer"
        trailingIcon={OpenInIcon}
      />
    </MenuBase>
  )
}
